export default function (state = 40, action = {}){
  switch (action.type) {
    case 'CHANGE_DISTANCE':
      return action.data.distance;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/config/allReducers/search/distanceReducer.js